import React from 'react';
import { Link } from 'react-router-dom'
import './Eula.css';
import logComponent from '../../common/logComponent';

export default function Eula() {

  if (logComponent('Eula')) { console.debug('Eula rendered'); }

  return (
    <Link to='../eula'
      target='_blank'>
      EULA
    </Link>
  )
}
